import { CSSProperties } from 'react'

export const s = {
  wrapper: {
    marginTop: 39,
    marginBottom: 39,
  },
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 21,
  } as CSSProperties,
  collapsed: {
    marginBottom: 25,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  } as CSSProperties,
}
